const LOCALE = 'de-CH';

/** "21:47:30" in lokaler Zeit */
export function formatClock(d: Date): string {
  return d.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

/** "Mo, 04.09. 21:47" */
export function formatDateTime(d: Date): string {
  return d.toLocaleString(LOCALE, {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Sekunden -> "2 h 14 min", "45 s", "3 min 05 s" */
export function formatDuration(totalSeconds: number): string {
  const s = Math.max(0, Math.round(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h} h ${m} min`;
  if (m > 0) return `${m} min ${String(sec).padStart(2, '0')} s`;
  return `${sec} s`;
}

/** Immer absolut UND relativ (Konzept, Abschnitt 10): "21:47:30 (in 2 h 14 min)" */
export function formatAbsRel(target: Date, now: Date): string {
  const diff = (target.getTime() - now.getTime()) / 1000;
  const rel = diff >= 0 ? `in ${formatDuration(diff)}` : `vor ${formatDuration(-diff)}`;
  return `${formatClock(target)} (${rel})`;
}

export function formatNumber(n: number): string {
  return Math.floor(n).toLocaleString(LOCALE);
}
